/**
 *
 * SymptomCodesPicker
 *
 */
import { httpClient } from 'api/HttpClient';
import { ISymptomCodeDto } from 'api/odata/generated/entities/ISymptomCodeDto';
import {
  Condition,
  ODataFilterBuilder,
  ODataOperators,
} from 'api/odata/ODataFilter';
import {
  AutocompletePicker,
  AutocompletePickerProps,
} from 'app/components/BasicPickers/AutocompletePicker';

import * as React from 'react';

import { Entity } from 'types/common';
export interface ISymptomCodesParamsPicker {
  AssetCats?: number[];
}
export interface SymptomCodesPickerProps
  extends Omit<AutocompletePickerProps<Entity<number>>, 'loadData'>,
    ISymptomCodesParamsPicker {}

const url = '/api/odata/v4/SymptomCodes';
export const initSymptomCodesData = (initval: string | undefined) => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    const id = parseInt(initval);
    const params: {
      $orderby: string;
      $filter?: string;
      $select: string;
      $top: number;
      $skip: number;
    } = {
      $orderby: 'Name asc',
      $filter: '(Id eq ' + id + ')',
      $select: `Id,Name,Active,AssetCatId,AssetCatName`,
      $skip: 0,
      $top: 1,
    };
    return httpClient
      .get(url, params)
      .then(response => response.value as Entity<number>[]);
  }
};

export function withParamsFilter(AssetCats: number[] | undefined) {
  if (!AssetCats || AssetCats.length < 1) {
    return (searchTerm: string | null) =>
      new Promise<Entity<number>[]>((resolve, reject) => {
        resolve([] as Entity<number>[]);
      });
  }
  return (searchTerm: string | null) => {
    const params: { $orderby: string; $filter?: string; $select?: string } = {
      $orderby: 'Name asc',
      $select: 'Id,Name,Active,AssetCatId,AssetCatName',
    };
    const predicates: (string | Condition<ISymptomCodeDto>)[] = [];
    if (AssetCats !== undefined && AssetCats.length > 0) {
      AssetCats.forEach(a =>
        predicates.push(new Condition('AssetCatId', ODataOperators.Equals, a)),
      );
    }
    params.$filter = new ODataFilterBuilder<ISymptomCodeDto>({
      predicates: predicates,
      stringColumns: ['Name'],
      stringSearch: searchTerm === null ? undefined : searchTerm,
      globalServiceGroupFilter: [],
    }).toString();
    return httpClient
      .get(url, params)
      .then(
        response => (response.value as ISymptomCodeDto[]) as Entity<number>[],
      );
  };
}
export function SymptomCodesPicker(props: SymptomCodesPickerProps) {
  const loadData = withParamsFilter(props.AssetCats);
  return (
    <AutocompletePicker
      mini={props.mini ? true : undefined}
      size={props.size}
      id={props.id || 'symptomcodesId'}
      loadData={loadData}
      {...props}
    />
  );
}
